export default __webpack_public_path__ + "static/media/printer.e8efe9ed.svg";